import { createTranslations } from '@npco/utils-translations'

export const introDescriptionTranslations = createTranslations({
  description:
    'Instantly start earning up to {interestRate}% p.a.* interest by adding money to a Zeller Savings Account. The more you save, the more you earn — including by transferring your daily settlements to your Zeller Savings Account. {termsText}',
  termsText: '{termsLink}',
  termsLink: 'Terms apply.',
})
